<template>
  <div v-if="order" class="orderList">
    <div class="cartItem">
      <div class="requestAt mb5 notranslate">
        <i class="orderId">{{locale.reservation_order_id}} {{order.order_id}}</i>
        <p class="paymentStatus">
          {{status}}
        </p>
      </div>
      <div class="inner">
        <div class="row">
          <span class="label toCapitalize notranslate">{{locale.reservation_use_space}}</span>
          <div class="value">{{summary.space.name[lang]}}</div>
        </div>
        <div class="row notranslate">
          <span class="label toCapitalize">{{locale.reservation_use_date}}</span>
          <div class="value">{{summary.displayDate}}</div>
        </div>
        <div class="row notranslate">
          <span class="label toCapitalize">{{locale.reservation_use_time}}</span>
          <div class="value">{{summary.time.name}}</div>
        </div>
        <div class="row notranslate">
          <span class="label toCapitalize">{{locale.reservation_use_person}}</span>
          <div class="value">{{summary.person}}</div>
        </div>
        <div class="row">
          <span class="label toCapitalize notranslate">{{locale.reservation_use_section}}/{{locale.reservation_use_place}}</span>
          <div v-if="summary.seats && !summary.autoAssign" class="value">
            <div v-for="info in summary.seats" :key="info.seat.id">
              {{info.section.name[lang]}}
              <span v-if="!summary.autoAssign && (summary.showPlaceName || summary.showSeatName)">
                -
                <span v-if="summary.showPlaceName">{{info.place.name[lang]}}</span>
                <span v-if="summary.showPlaceName && summary.showSeatName"> / </span>
                <span v-if="summary.showSeatName">{{info.seat.name[lang]}}</span>
              </span>
            </div>
          </div>
          <div v-else class="value">
            {{summary.section.name[lang]}}
            <span v-if="!summary.autoAssign && (summary.showPlaceName || summary.showSeatName)">
                -
              <span v-if="summary.showPlaceName">{{summary.place.name[lang]}}</span>
              <span v-if="summary.showPlaceName && summary.showSeatName"> / </span>
              <span v-if="summary.showSeatName">{{summary.seat.name[lang]}}</span>
            </span>
          </div>
        </div>
        <div v-if="summary.firstName" class="row notranslate">
          <span class="label toCapitalize">{{locale.reservation_book_first_name}}</span>
          <div class="value">{{summary.firstName}}</div>
        </div>
        <div v-if="summary.lastName" class="row notranslate">
          <span class="label toCapitalize">{{locale.reservation_book_last_name}}</span>
          <div class="value">{{summary.lastName}}</div>
        </div>
        <div v-if="summary.phone" class="row notranslate">
          <span class="label toCapitalize">{{locale.reservation_book_phone}}</span>
          <div class="value">{{summary.phone}}</div>
        </div>
        <div v-if="summary.email" class="row notranslate">
          <span class="label toCapitalize">{{locale.reservation_book_email}}</span>
          <div class="value">{{summary.email}}</div>
        </div>
        <div class="row notranslate">
          <span class="label toCapitalize">{{locale.reservation_reservation_date}}</span>
          <div class="value">{{setDateTimeFormat(order.createat)}}</div>
        </div>
        <div v-if="order.cancelled && order.cancelledat" class="row notranslate">
          <span class="label toCapitalize">{{locale.reservation_cancel_date}}</span>
          <div class="value">{{setDateTimeFormat(order.cancelledat)}}</div>
        </div>
      </div>
    </div>
    <!-- <Qrcode
      :reservationId="order.order_id"  /> -->
    <div v-if="cancellable && cancellable.isCancel" class="cancelReservation notranslate">
      <div v-if="cancellable.ready">
        <p class="cancelMessage mb10">{{cancellable.message}}</p>
        <button
          type="submit"
          class="btn btnFull btnWhite"
          :disabled="!cancellable.isCancellable"
          @click="cancel">{{locale.reservation_cancel}}</button>
      </div>
      <p v-if="order.cancelled && order.cancelledat" class="completeCancel">
        {{locale.reservation_already_cancel}}
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'
import { DateTime } from 'luxon'
import Qrcode from '@/components/Reservation/Qrcode'

export default {
  name: 'CheckReservation',
  props: [
    'ln',
    'lang',
    'locale',
    'isPublic',
    'reservationId'
  ],
  components: {
    Qrcode
  },
  computed: {
    auth () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    dateFormat () {
      return this.$store.getters['common/getDateFormat']
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    isPrivate () {
      const noFrame = (this.auth.frame && this.auth.frame === 'false') || false
      return this.isPublic && noFrame
    },
    summary () {
      return this.order.ordersheet.content
    },
    status () {
      let status = this.locale.reservation_status_ready
      if (this.order.order_status === 'cancel') {
        status = this.locale.reservation_status_cancel
      }
      return status
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      order: null,
      cancellable: null,
      info: null
    }
  },
  methods: {
    init () {
      const reservationId = this.reservationId
      function getTimeDisplay (hhmm) {
        const time = hhmm.toString()
        return `${time.substr(0, 2)}:${time.substr(2, 2)}`
      }
      this.$store.dispatch('reservation/getReservationInfo', reservationId).then((res) => {
        if (res) {
          this.order = res
          const property = res.reservationSpaceId
          this.$store.dispatch('reservation/getReservationPropertyInfo', property).then((info) => {
            if (info) {
              // 예약취소 가능여부 확인
              const ready = this.order.order_status === 'ready'
              const date = this.order.ordersheet.content.date
              const time = this.order.ordersheet.content.time.id.substr(0, 4)
              const time2 = this.order.ordersheet.content.time.id.substr(4, 4)
              const isCancel = info.cancel
              const cancelDay = info.cancelDay
              const cancelTime = info.cancelTime
              const endTime = moment().set({ hour: time.substr(0, 2), minute: time.substr(2, 2) }).add(-cancelTime, 'minutes')
              const beforeToday = moment().isBefore(moment(date).add(-cancelDay, 'days').set({ hour: 0, minute: 0 }))
              const isToday = moment().format('YYYY-MM-DD') === date
              const isTime = moment().isBefore(endTime)
              const limitDay = cancelDay > 0 ? this.setDateFormat(moment(date).add(-cancelDay, 'days').format('YYYY-MM-DD')) : this.setDateFormat(date)
              const limitTime = cancelDay > 0 ? '' : getTimeDisplay(endTime.format('HHmm'))
              this.cancellable = {
                ready: ready,
                isCancel: isCancel,
                cancelDay: cancelDay,
                beforeToday: beforeToday,
                isToday: isToday,
                isTime: isTime,
                isCancellable: ready && (beforeToday || (cancelDay <= 0 && isToday && isTime)),
                limitDay: limitDay,
                limitTime: limitTime,
                message: this.locale.message_reservation_cancel_time.replace('{var}', `${limitDay} ${limitTime}`)
              }
            }
          })
        }
      })
    },
    setDateFormat (date) {
      return moment(date).format(this.dateFormat.toUpperCase())
    },
    setDateTimeFormat (iso) {
      const submitAt = DateTime.fromISO(iso || moment().toISOString(), { zone: this.timezone })
      return submitAt.toFormat(this.format)
    },
    cancel () {
      if (window.confirm(this.locale.confirm_reservation_cancel)) {
        const reservationId = this.reservationId
        this.$store.dispatch('reservation/cancelReservation', reservationId).then((res) => {
          if (res) {
            if (res.includes('ok')) {
              // 취소가 완료되었습니다.
              alert(this.locale.alert_complete_reservation_cancel)
              this.init()
            } else if (res.includes('notFound')) {
              // 예약번호를 찾을 수 없습니다.
              alert(this.locale.alert_notfound_reservation_id)
            } else if (res.inlucdes('alreadyCancel')) {
              // 이미 취소된 예약번호입니다.
              alert(this.locale.alert_already_reservation_cancel)
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content .cartItem {
  margin: 15px;
  .inner {
    display: block;
  }
  .row {
    display: flex;
    & + .row {
      margin-top: 15px;
    }
  }
  .label {
    font-weight: bold;
  }
  .value {
    margin-left: 1em;
  }
}
.usableState {
  text-align: center;
  font-size: 1.2em;
  color: $color-lgrey;
  &[data-state="now"] {
    color: $color-green;
  }
  span {
    
  }
}
.cancelReservation {
  position: relative;
  margin-top: 15px;
  padding: 30px 15px;
  text-align: center;
  border-top: 1px dashed $color-lgrey2;
  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 0;
    margin-top: -10px;
    border-style: solid;
    border-width: 10px;
    border-color: transparent;
  }
  &:before {
    left: 0;
    border-left-color: $color-lgrey2;
  }
  &:after {
    right: 0;
    border-right-color: $color-lgrey2;
  }
  .btn {
    border-radius: 4px;
    &[disabled] {
      color: $color-white;
    }
  }
  .cancelMessage {
    font-size: 14px;
    color: $color-lgrey;
  }
}
</style>
